import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import * as Fa from "react-icons/fa";
import { toast } from "react-toastify";
import storage from "../../Services/Storage";
import {
    createAPIBankingTransaction,
    EndpointBankingTransaction,
} from "../../Services/BankingTransaction/BankingTransactionService";
import Loader from "../../Components/Loader";
import { useNavigate } from "react-router-dom";
import { utils, writeFile } from "xlsx";
import { GetDateFormat } from "../../Services/GlobalFunc/DateFormat";

const BankingTransactionAllRecords = () => {
    const [startDate, setStartDate] = useState(() => {
        let date = new Date();
        date.setDate(date.getDate() - 7);
        return date;
    });
    const [endDate, setEndDate] = useState(new Date());
    const [chequeRecordsData, setChequeRecordsData] = useState([]);
    const auth = storage.getLocal("user");
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingxl, setIsLoadingxl] = useState(false);
    const nav = useNavigate();

    const getAllChequeRecordsData = async () => {
        setIsLoading(true);
        const formattedStartDate = new Intl.DateTimeFormat("en-GB").format(
            startDate
        );
        const formattedEndDate = new Intl.DateTimeFormat("en-GB").format(endDate);

        try {
            const response = await createAPIBankingTransaction().get(
                `${EndpointBankingTransaction.GetAllChequeRecords}?CompId=${auth.CompId}&FromDate=${formattedStartDate}&ToDate=${formattedEndDate}`
            );
            setChequeRecordsData(response.data.Data ?? []);
            setIsLoading(false);
        } catch (err) {
            console.log("Error ", err);
            toast.error("Unable to get Data", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            setIsLoading(false);
        }
    };
    useEffect(() => {
        getAllChequeRecordsData();
    }, []);

    const handleExport = async () => {
        setIsLoadingxl(true);
        const formattedStartDate = new Intl.DateTimeFormat("en-GB").format(
            startDate
        );
        const formattedEndDate = new Intl.DateTimeFormat("en-GB").format(endDate);
        try {
            const response = await createAPIBankingTransaction().get(
                `${EndpointBankingTransaction.ExportAllChequeRecords}?CompId=${auth.CompId}&FromDate=${formattedStartDate}&ToDate=${formattedEndDate}`
            );
            if (response.data.Data && response.data.Data.length > 0) {
                exportToExcel(response.data.Data);
            } else {
                toast.info("No data available to export!", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
            }
            setIsLoadingxl(false);
        } catch (err) {
            toast.error(err.message, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            setIsLoadingxl(false);
        }
    };

    const exportToExcel = (data) => {
        if (!data || data.length === 0) {
            toast.error("No data to export!", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        }
        let filename = `ChequeRecords_${GetDateFormat()}`;
        const ws = utils.json_to_sheet(data);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, filename);
        writeFile(wb, `${filename}.xlsx`);
    };

    return (
        <>
            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Banking Transaction</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="text-end mb-2">
                            <button
                                type="button"
                                className="btn btn-outline-primary me-3"
                                onClick={handleExport}
                                disabled={isLoadingxl}
                            >
                                {isLoadingxl ? "Loading..." : "Export All"}{" "}
                                {isLoadingxl ? (
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                ) : (
                                    <Fa.FaFileExport className="ms-2" />
                                )}
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => {
                                    nav("/creditmanagement/bankingtransaction/details");
                                }}
                            >
                Add New
                            </button>
                        </div>
                    </div>
                </div>
                <section className="sales-box">
                    <div className="row d-flex justify-content-end align-items-end">
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <label className="form-label">From Date</label>
                            <Calendar
                                value={startDate}
                                onChange={(e) => setStartDate(e.value)}
                                showIcon
                                dateFormat="dd/mm/yy"
                            />
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <label className="form-label">To Date</label>
                            <Calendar
                                value={endDate}
                                onChange={(e) => setEndDate(e.value)}
                                showIcon
                                dateFormat="dd/mm/yy"
                            />
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="text-end">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={getAllChequeRecordsData}
                                >
                  Get Data
                                </button>
                            </div>
                        </div>
                    </div>
                </section>

                <section>
                    <h3 className="py-2">Records</h3>
                    {isLoading ? (
                        <>
                            <Loader />
                        </>
                    ) : (
                        <div className="DataTable">
                            <DataTable
                                paginator
                                rows={10}
                                value={chequeRecordsData}
                                rowsPerPageOptions={[10, 25, 50]}
                                scrollHeight="80vh"
                                // showGridlines
                                scrollable
                                filterDisplay="row"
                                stripedRows
                                emptyMessage="No Record found"
                            >
                                <Column
                                    field="MASK_PAY_IN_SLIP_NO"
                                    header="Slip Number"
                                    filter
                                    filterMatchMode="contains"
                                    filterPlaceholder="Search Here..."
                                ></Column>
                                <Column
                                    field="MASK_PAY_IN_SLIP_DATE"
                                    header="Slip Date"
                                ></Column>
                                <Column field="CHEQUE_DRAFT_DATE" header="Cheque Date"></Column>
                                <Column
                                    field="MASK_BANK_NAME"
                                    header="Bank Name"
                                    filter
                                    filterMatchMode="contains"
                                    filterPlaceholder="Search Here..."
                                ></Column>
                                <Column
                                    field="CUSTOMER_NAME"
                                    header="Customer Name"
                                    filter
                                    filterMatchMode="contains"
                                    filterPlaceholder="Search Here..."
                                ></Column>
                                <Column
                                    field="RECEIRT_NO"
                                    header="Receipt Number"
                                    filter
                                    filterMatchMode="contains"
                                    filterPlaceholder="Search Here..."
                                ></Column>
                                <Column field="RECEIPT_DATE" header="Receipt Date" filter
                                    filterMatchMode="contains"
                                    filterPlaceholder="Search Here..."></Column>
                                <Column field="AMOUNT" header="Amount"></Column>
                                <Column field="BOUNCED_TAG" header="Status"></Column>
                            </DataTable>
                        </div>
                    )}
                </section>
            </div>
        </>
    );
};

export default BankingTransactionAllRecords;
